import { render, staticRenderFns } from "./DaftarView.vue?vue&type=template&id=db9c8886&"
import script from "./DaftarView.vue?vue&type=script&lang=js&"
export * from "./DaftarView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports